import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { useQuery } from '../hooks/useQuery';
import { decryptData, handleHttpError } from '../utils';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from '../hooks/useSnackbar';
import { CircularProgress, TextField } from '@mui/material';
import Moment from 'moment';

export default function DetalheNotaFiscalStep1() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  let { nota_fiscal_id } = useParams();
  const theme = useTheme();

  const { obterNotaFiscalPorId } = useQuery();

  const [isLoading, setIsLoading] = React.useState(true);
  const [nota, setNota] = React.useState(null);

  React.useEffect(() => {
    const id = decryptData(nota_fiscal_id);

    if (!id) {
      navigate(-1);
      return;
    }
    fetchNotaFiscal(id);
  }, []);

  const fetchNotaFiscal = async (id) => {
    try {
      let { data } = await obterNotaFiscalPorId(id);
      setNota(data.data);
      setIsLoading(false);
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    }
  };

  const renderContent = () => {
    if (isLoading) return <CircularProgress />;

    if (!nota) return <div />;

    return (
      <>
        <Grid container gap={1}>
          <Grid item display="flex" flexDirection="column">
            <span>Natureza da operação:</span>
            <TextField
              disabled
              value={nota.natureza_operacao === '1' ? 'Serviço' : 'Produto'}
              variant="outlined"
            />
          </Grid>
          <Grid item display="flex" flexDirection="column">
            <span>Tipo envio:</span>
            <TextField
              disabled
              value={
                nota.tipo_envio_nf === 'M'
                  ? 'Manual'
                  : nota.tipo_envio_nf === 'X'
                  ? 'XML'
                  : 'PDF'
              }
              variant="outlined"
            />
          </Grid>
        </Grid>
        <Grid container marginTop={2}>
          <Grid container gap={1}>
            <Grid item display="flex" flexDirection="column">
              <span>Município:</span>
              <TextField
                disabled
                value={nota.uf_orgao_gerador}
                variant="outlined"
              />
            </Grid>
            <Grid item display="flex" flexDirection="column">
              <span>Cidade:</span>
              <TextField
                disabled
                value={` ${
                  !nota.municipio_orgao_gerador
                    ? ''
                    : nota.municipio_orgao_gerador.nome_municipio
                }`}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container marginTop={2} gap={1}>
          <Grid item display="flex" flexDirection="column">
            Número NF:
            <TextField disabled value={nota.numero_nf} variant="outlined" />
          </Grid>
          <Grid item display="flex" flexDirection="column">
            Data emissão:
            <TextField
              disabled
              value={Moment(nota.data_emissao_nf).format('DD/MM/YYYY')}
              variant="outlined"
            />
          </Grid>
          <Grid item display="flex" flexDirection="column">
            Validade bloco:
            <TextField
              disabled
              value={
                nota.validade_bloco
                  ? Moment(nota.validade_bloco).format('DD/MM/YYYY')
                  : ''
              }
              variant="outlined"
            />
          </Grid>
        </Grid>

        <Grid container>
          <h3>Fornecedor</h3>
        </Grid>

        <Grid container display="flex" flexDirection="column">
          <TextField disabled value={nota.razao_social} variant="outlined" />
          <Grid container marginTop={2} gap={1}>
            <Grid item display="flex" flexDirection="column">
              CNPJ:
              <TextField
                disabled
                value={nota.cnpj_prestador_servico}
                variant="outlined"
              />
            </Grid>
            <Grid item display="flex" flexDirection="column">
              Telefone:
              <TextField
                disabled
                value={nota.telefone_contato}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container marginTop={2}>
            <Grid item container display="flex" flexDirection="column">
              <span>Email:</span>
              <TextField
                disabled
                value={nota.email_contato}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container marginTop={2}>
            <Grid item container display="flex" flexDirection="column">
              <span>Endereço:</span>
              <TextField disabled value={nota.endereco} variant="outlined" />
            </Grid>
          </Grid>
          <Grid container marginTop={2}>
            <Grid item display="flex" flexDirection="column">
              Bairro:
              <TextField disabled value={nota.bairro} variant="outlined" />
            </Grid>
          </Grid>
          <Grid container marginTop={2} gap={1}>
            <Grid item display="flex" flexDirection="column">
              Valor:
              <TextField
                disabled
                value={Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(nota.valor_servico)}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container marginTop={2}>
            <Grid item container display="flex" flexDirection="column">
              <span>Discriminação:</span>
              <TextField
                margin="0"
                disabled
                value={nota.discriminacao_servico}
                id="discriminacao"
                multiline
                rows={4}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <Card
      variant="outline"
      style={{
        borderTop: `8px solid ${theme.palette.primary.main}`,
        marginTop: '1.4rem',
      }}
    >
      <CardContent padding="10px">
        <Grid container spacing={1} marginTop={2} display="flex">
          {renderContent()}
        </Grid>
      </CardContent>
    </Card>
  );
}
